import { getMultiPrivatFilmingFormData, PrivateFilmingFormDataResponse } from '@api/filming';
import QueryKeys from '@lib/constants/QueryKeys';
import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

export default function useGetMultiFilmingPermitForm() {
  return useQuery<PrivateFilmingFormDataResponse, AxiosError>(QueryKeys.multiFilmingPermitForm(), () => getMultiPrivatFilmingFormData());
}
